import { render, staticRenderFns } from "./RiaInternational.vue?vue&type=template&id=266b36d6&scoped=true"
import script from "./RiaInternational.vue?vue&type=script&lang=js"
export * from "./RiaInternational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b36d6",
  null
  
)

export default component.exports